<script setup lang="ts">
import { onMounted, ref } from 'vue'
import PlayAgentGame from '@/components/voice-agent/PlayAgentGame.vue'
import { useApi } from '@/composables/useApi'

const route = useRoute('games-play-id')
const router = useRouter()

definePage({
  meta: { action: 'read', subject: 'games' },
})

const initialLoading = ref(true)
const gamesBlocked = ref(false)
const { t } = useI18n()
const gameId = route.params.id as string

onMounted(async () => {
  // Redirect completed games to detail page
  try {
    const { data } = await useApi<any>(`/games/${gameId}`)
    if (data?.value?.status === 'completed') {
      await router.push({ name: 'games-detail-id', params: { id: gameId } })

      return
    }
  }
  catch (error) {
    console.error('Error fetching game status:', error)
  }

  // Новая версия экрана — по текущему флагу организации из `game-session`, а не по снимку флагов
  // при входе. Нет ответа — прежний экран: он сам прочитает `game-session` и разберёт ошибку.
  try {
    const { data: sessionData } = await useApi<{ new_session_screen?: boolean }>(`/voice-agent/game-session/${gameId}`)
    if (sessionData.value?.new_session_screen === true) {
      await router.replace({ name: 'games-session-id', params: { id: gameId } })

      return
    }
  }
  catch {
    // non-critical
  }

  try {
    const { data: maintenanceData } = await useApi<any>('/maintenance/status').get().execute(true)
    if (maintenanceData.value?.gamesBlocked)
      gamesBlocked.value = true
  }
  catch {
    // non-critical
  }

  initialLoading.value = false
})
</script>

<template>
  <!-- Loading: game status and maintenance check -->
  <div
    v-if="initialLoading"
    class="d-flex align-center justify-center"
    style="min-height: 100vh;"
  >
    <VProgressCircular
      indeterminate
      size="48"
      color="primary"
    />
  </div>

  <!-- Games blocked by maintenance -->
  <VContainer
    v-else-if="gamesBlocked"
    class="d-flex align-center justify-center"
    style="min-height: 80vh;"
  >
    <VAlert
      type="warning"
      prominent
      max-width="600"
      class="text-center"
    >
      {{ t('maintenance-page.games_blocked_message') }}
    </VAlert>
  </VContainer>

  <PlayAgentGame
    v-else
    :game-id="gameId"
  />
</template>
